import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.white,
  secondaryBgColor: colors.white,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default imageSlider;